import React from 'react';
import { Dialog, DialogContent, IconButton,} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({ "& .MuiDialog-paper": { width: '380px', maxWidth: '90%', borderRadius: '8px', padding: theme.spacing(2), fontFamily: 'Poppins', paddingTop: theme.spacing(1), boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)", position: 'relative',},}));

const CloseButton = styled(IconButton)({ position: 'absolute', top: 8, right: 8,});

const ReusableModal = ({ open, onClose, children }) => {
  return (
      <StyledDialog open={open} onClose={onClose} BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.1)', backdropFilter: 'blur(0.5px)',},}}>
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
        <DialogContent sx={{ textAlign: 'center', paddingTop: 1, paddingBottom: 2, }}>
        {children}
        </DialogContent>
    </StyledDialog>
  );
};

export default ReusableModal;
